<template>
  <article class="">
    <div class="table_card">
      <div class="table_card__head">
        <p class="table_card__head--title">
          Búsqueda de usuario
        </p>
      </div>
      <div class="table_card__body">
        <v-flex xs12 row>
          <v-form
            onSubmit="return false;"
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-layout row wrap style="background-color: #fff; padding: 0px;">
              <v-flex xs6>
                <input
                  v-model="rut"
                  placeholder="Ingrese el documento del usuario"
                  required
                  class="input_solid"
                  style="width: 98% !important"
                />
                <img
                  src="@/assets/img/icons/search-icon.svg"
                  class="button_search"
                  style="margin-left: -55px"
                />
              </v-flex>
              <v-flex xs6 class="pl-2">
                <button
                  type="button"
                  class="faccess_button px-5"
                  @click="findTicketsByRut()"
                  :disabled="!valid || searching_rut == ''"
                >
                  Consultar
                </button>
              </v-flex>
            </v-layout>
          </v-form>
        </v-flex>
      </div>
      <div class="table_card__body">
        <section class="ticket_list" v-if="tickets.length > 0">
          <p class="ticket_list__title">Tickets</p>
          <section
            v-for="ticket in tickets"
            :key="ticket.id"
            @click="showTicket(ticket)"
            class="ticket_list__container"
          >
            <div class="ticket_list__section">
              <div class="ticket_list__section--icon">
                <v-icon dark v-text="'print'"></v-icon>
              </div>
              <div class="ticket_list__section--text-container">
                <p class="ticket_list__section--title">
                  Ticket de acceso desde counter de Impresion
                </p>
                <!-- <p class="ticket_list__section--subtitle">
                  {{ ticket.email }}
                </p> -->
              </div>
            </div>
          </section>
        </section>
        <section v-else>
          <p class="ticket_list__section--subtitle">
            El usuario no tiene acceso
          </p>
        </section>
      </div>
    </div>
    <section class="modal_info" v-if="show_ticket && qr_string != null">
      <section
        class="modal_info__modal"
        style="height:fit-content;border-radius:5px; max-width: 400px;"
      >
        <div class="qr_content" ref="qr_content">
          <vue-qrcode
            id="print"
            errorCorrectionLevel="L"
            class="qr_content__qr"
            :value="qr_string"
            v-for="n in 4"
            :key="n"
          ></vue-qrcode>
        </div>
        <div
          id="noprint"
          class="modal_info__modal__buttons"
          style="position: static!important"
          v-show="notPrint"
        >
          <button
            class="modal_info__modal__buttons--cancel"
            @click="cancelTicket()"
          >
            Cancelar
          </button>
          <button
            class="modal_info__modal__buttons--confirm"
            @click="printTicket()"
          >
            Imprimir Ticket
          </button>
        </div>
        <div
          class="modal_info__modal__noprint"
          v-show="printMessage"
          id="noprint"
        >
          Abriendo configuracion de impresión, esto puede tardar unos
          segundos...
        </div>
      </section>
    </section>
  </article>
</template>

<script>
export default {
  data() {
    return {
      qr_string: null,
      show_ticket: true,
      rut: "",
      searching_rut: "",
      rules: {
        required: value => !!value || "Requerido."
      },
      user_finded: false,
      valid: false,
      tickets: [],
      bookings: [],
      isOnLine: true,
      notPrint: true,
      printMessage: false,
      isInPetition: false
    };
  },
  watch: {
    rut() {
      this.searching_rut = this.rut.toUpperCase();
    }
  },
  methods: {
    async findTicketsByRut() {
      if (!this.isInPetition) {
        this.isInPetition = true;
        const controller = new AbortController();
        // 5 second timeout:
        const timeoutId = setTimeout(() => {
          controller.abort();
          this.updateAlertMessage(
            "Error de conexión con la ip: verifica tu conexion a red local, que estes a la misma red y que hallan iniciado sesion correctamente en el Counter Offline"
          );
          this.updateIsInAlert(true);
          this.updateIsLogin(false);
        }, 2500);
        let counterPort = 8081;
        if (window.eel) {
          counterPort = await window.eel.eel_get_config_port()();
        }
        fetch(
          `http://${this.getEmailUser()}:${counterPort}/search_active_tickets`,
          {
            signal: controller.signal,
            method: "POST",
            mode: "cors",
            headers: {
              Authorization: "Bearer " + this.getUserToken(),
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              identification_number: btoa(this.searching_rut)
            })
          }
        )
          .then(response => response.json())
          .then(data => {
            console.log(data);
            clearTimeout(timeoutId);
            this.isInPetition = false;
            this.tickets = [];
            if (data.status == "422") {
              this.updateAlertMessage(data.error_message);
              this.updateIsInAlert(true);
            } else if (data.status == "200") {
              this.tickets = data.tickets.split(";");
            }
          })
          .catch(error => {
            console.log(error);
            clearTimeout(timeoutId);
            this.updateAlertMessage(
              "Error de conexión con la ip: verifica tu conexion a red local, que estes a la misma red y que hallan iniciado sesion correctamente en el Counter Offline"
            );
            this.updateIsInAlert(true);
            this.updateIsLogin(false);
          });
      }
    },
    showTicket(qr) {
      this.qr_string = qr;
      this.show_ticket = true;
    },
    cancelTicket() {
      this.qr_string = null;
      this.show_ticket = false;
    },
    printTicket() {
      this.notPrint = false;
      this.printMessage = true;
      setTimeout(() => {
        window.print();
      }, 1);
      window.onafterprint = () => {
        this.printMessage = false;
        this.notPrint = true;
      };
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/bookingOffice/CounterPrinter.vue